/**
 * TASKS-TOPIC-LABEL.WIDGET
 * Display name of the topic for one task
 */
import { Topic } from "@/redux/topic.types"

interface OwnProps {
  currentTopic: Topic
  withNote?: boolean
}

function TasksTopicLabelWidget(props: OwnProps) {
  return (
    <div className="text-sm mb-1 font-bold" style={{ color: props.currentTopic.Axis?.color }}>
      {props.currentTopic.note != null && props.currentTopic.note > 0 && (
        <span className="text-sm" style={{ color: props.currentTopic.Axis?.color }}>
          <b>{(props.currentTopic.note / 10).toFixed(1)}</b>
          &nbsp;-&nbsp;
        </span>
      )}
      {props.currentTopic.label}
    </div>
  )
}

export default TasksTopicLabelWidget
